import type { City, GroupedStations } from "@repo/ui/types/stations";

export default function transformStationData(data: City[]): GroupedStations {
  return data.reduce<GroupedStations>((acc, station) => {
    const countryName = station.country?.countryName || "Unknown";

    if (!acc[countryName]) {
      acc[countryName] = [];
    }

    acc[countryName]?.push({
      ...station,
    });

    return acc;
  }, {});
}

export function getAvailableDestinations(
  allStations: City[],
  selectedDepartureCode: string,
): GroupedStations {
  const departure = allStations.find((station) => station.code === selectedDepartureCode);

  if (!departure?.route?.connection) return {};

  const arrivalCodes = new Set(departure.route.connection.map((conn) => conn.arrivalStation));

  const normalizedArrivalCodes = new Set<string>();

  arrivalCodes.forEach((code) => {
    const station = allStations.find((s) => s.code === code);
    if (station?.macCode) {
      normalizedArrivalCodes.add(station.macCode);
    } else {
      normalizedArrivalCodes.add(code);
    }
  });

  const destinationStations = allStations.filter(
    (station) => normalizedArrivalCodes.has(station.code) && !station.hidden,
  );

  return transformStationData(destinationStations);
}

export function getAvailableDepartures(
  allStations: City[],
  selectedArrivalCode: string,
): GroupedStations {
  const targetCodes = new Set<string>([selectedArrivalCode]);

  allStations.forEach((station) => {
    if (station.macCode === selectedArrivalCode) {
      targetCodes.add(station.code);
    }
  });

  const matchingDepartures = allStations.filter((station) => {
    if (station.hidden) return false;

    return station.route?.connection?.some((conn) => targetCodes.has(conn.arrivalStation));
  });

  return transformStationData(matchingDepartures);
}
